import { Button, Spin, Typography } from "antd";
import { AxiosError } from "axios";
import { useTranslation } from "react-i18next";

import { useMutation } from "@tanstack/react-query";
import { approveRequestByNumber } from "entities/requests";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { notification } from "shared/lib/antd-global";
import styles from "./index.module.scss";
import ROUTES from "shared/routes";

export const ConfirmShiftPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { number } = useParams();

  const {
    mutate: approveRequest,
    isPending: isApproveRequestPending,
    data,
  } = useMutation({
    mutationFn: (number: string) => approveRequestByNumber(number),
    onSuccess() {
      notification.success({ title: t("shift_approve.approved") });
    },
    onError(error: AxiosError<{ message: string }>) {
      notification.error({
        title:
          error.response?.data?.message || t("shift_approve.something_wrong"),
      });
    },
  });

  useEffect(() => {
    if (number) {
      approveRequest(number);
    }
  }, [number, approveRequest]);

  return (
    <>
      <Typography.Title level={3} style={{ textAlign: "center" }}>
        {t("shift_approve.title")}
      </Typography.Title>

      <div className={styles.wrapper}>
        {isApproveRequestPending ? (
          <Spin />
        ) : data ? (
          <>
            <Typography.Text style={{ fontSize: 16 }}>
              {t("shift_approve.approved_text")}
            </Typography.Text>

            <Button block type="primary" onClick={() => navigate(ROUTES.MAIN)}>
              {t("shift_approve.go_to_main")}
            </Button>
          </>
        ) : (
          <>
            <Typography.Text style={{ fontSize: 16 }}>
              {t("shift_approve.not_approved")}
              <br /> {t("shift_approve.contact_employer")}
            </Typography.Text>

            <Button block type="primary" onClick={() => navigate(ROUTES.MAIN)}>
              {t("shift_approve.go_to_main")}
            </Button>
            <Button block onClick={() => number && approveRequest(number)}>
              {t("shift_approve.try_again")}
            </Button>
          </>
        )}
      </div>
    </>
  );
};
